import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import seoTemplatesService from "../../services/seoTemplatesService";

// Queries
export const useGetSEOTemplates = (queryOptions = {}) => {
  return useQuery(["seoTemplates"], seoTemplatesService.index, queryOptions);
};

// Mutations
export const useUpdateSEOTemplates = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation((params) => seoTemplatesService.update(params), {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["seoTemplates"], data);
      mutationOptions.onSuccess(data);
    },
  });
};
